import React, { useState, useEffect } from "react";
import {
    Box, Typography, Button, TextField, MenuItem, FormControl, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper, Icon, InputAdornment,
    Dialog, DialogTitle, DialogContent, DialogActions, Tooltip
} from "@mui/material";
import Loader from "../../components/Loader";
import { withTranslation } from "react-i18next";
import { Delete, Cancel } from "@mui/icons-material";
import { GetCountryAdminListSearchUrl, DeleteCountryAdminUrl, getFillListUrl, countryActionID, dashboardGroupCountryActionID } from "../../utils/constants";
import CommonPagination from "../../components/CommonPagination";
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import { HeaderBlock } from "@colliers/colliers-b2c";

const CountryList = (_props) => {
    const { ToastComponent, showToast } = useToast();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [dropdownList, setDropdownList] = useState([]);
    const [countryID, setcountryID] = useState("0");
    const [countryName, setcountryName] = useState("");
    const setdashboardGroup = useState(null);
    const [status, setStatus] = useState("Active");

    const handlecountryNameChange = (event) => { setcountryName(event.target.value); };
    const handleStatusChange = (event) => { setStatus(event.target.value); };

    // Handle change event
    const handleChange = (event) => {
        setcountryID(event.target.value);
    };
    const navigate = useNavigate();
    const [reset, setReset] = useState(false);
    const [dashboardGroupList, setdashboardGroupList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredDashboardGroups, setFilteredDashboardGroups] = useState(dashboardGroupList)
    const listItemsPerPage = 10;
    const totalItems = filteredDashboardGroups?.length;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedCountryList = filteredDashboardGroups?.slice(startIndex, startIndex + listItemsPerPage);

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate("/login/KeyStone_Login");
            return;
        } else {
            fetchData();
            getCountryList();
        }
    }, [reset]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = await axiosGet(getFillListUrl, {
                actionID: dashboardGroupCountryActionID, valueID: 0, keyValue: null
            });
            if (data != null && data.length > 0) { setDropdownList(data); }
            else { console.error("Failed to fetch country list: No data found."); }
        }
        catch (error) {
            console.error("Error fetching country list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getCountryList = async () => {
        setIsLoading(true);
        try {
            let resolvedStatus;
            if (status === "Active") {
                resolvedStatus = true;
            } else if (status === "" || status === "0") {
                resolvedStatus = null;
            } else { resolvedStatus = false }

            const dashboardGroupSearchParam = {
                countryName: (countryName == "" || countryName == null || countryName == undefined) ? "" : countryName,
                status: resolvedStatus
            };
            const response = await axiosGet(`${GetCountryAdminListSearchUrl}?countryName=${countryName ? countryName : ""}&status=${resolvedStatus}`);
            if (response) {
                setdashboardGroupList(response);
                setFilteredDashboardGroups(response);
            } else {
                showToast('error', 'Failed to fetch dashboard groups: No data found.');
                console.error("Failed to fetch dashboard groups: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard groups:", error);
        } finally { setIsLoading(false); }
    };
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [editCountryID, seteditCountryID] = useState('');

    const toggleDeleteModal = (editCountryID, countryName) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            seteditCountryID('');
            setcountryName('')
        } else {
            console.log(editCountryID, countryName)
            setDeleteModal(true);
            seteditCountryID(editCountryID);
            setcountryName(countryName)
        }
    };
    const handleDelete = async (deleteCountryID) => {
        setIsLoading(true);
        try {
            const response = await axiosGet(`${DeleteCountryAdminUrl}?deleteCountryID=${deleteCountryID}`);
            if (response) {
                if (response.code !== 200) {
                    showToast('error', response.responseMsg ? response.responseMsg : 'Failed to Delete Country')
                } else {
                    showToast('success', 'Successfully Deleted!');
                }
                //swindow.location.reload()
            }
        } catch (error) {
            console.error("Error fetching dashboard groups:", error);
            showToast('error', `Error fetching dashboard groups:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false);
        }
    }
    const searchBtnCall = async () => {
        getCountryList();
        setReset(false)
    }
    const resetSearch = async () => {
        setcountryID("0");
        setcountryName("");
        setStatus("Active");
        setReset(true)
    }
    const editGroup = async (editCountryID) => {
        navigate("/country-manage", { state: { editCountryID: editCountryID } });
    }

    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('common.country')}
                actions={<Button className="add-dashbaord-btn" variant="outlined"
                    startIcon={<i className="fa fa-plus margin-right-xs" />}
                    onClick={() => navigate("/country-manage")}>
                    {t('common.Add')}
                </Button>}
                leftCenterAlign="true" actionsCenterAlign="true" />
            <main id="main"
                className="countryListMain">
                <Box className="pagetitle main-area-top" textAlign="center">
                    <section className="section page-body">
                        <Box className="margin-top-base margin-bottom-none" sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "flex-start", }}>

                            <FormControl className="list-page-control-dashboard-group">
                                <TextField className="padding-top-s margin-bottom-s text-align-left"
                                    label={t('dashboardGroup.country')}
                                    placeholder={t('dashboardGroup.country')}
                                    variant="outlined" fullWidth value={countryName}
                                    onChange={handlecountryNameChange}
                                    InputProps={{ startAdornment: (<InputAdornment position="start" />) }} />
                            </FormControl>
                            <FormControl className="list-page-control-dashboard-group">
                                <TextField
                                    className="padding-top-s margin-bottom-s text-align-left"
                                    label={t('dashboardGroup.status')}
                                    onChange={handleStatusChange}
                                    value={status} select fullWidth
                                    variant="outlined" >
                                    <MenuItem value="0">{t('dashboardGroup.selectStatus')}</MenuItem>
                                    <MenuItem value="Active">{t("common.active")}</MenuItem>
                                    <MenuItem value="Inactive">{t("common.inactive")}</MenuItem>
                                </TextField>
                            </FormControl>
                            <Button className="margin-left-base margin-right-xs" variant="contained" sx={{ alignSelf: "center" }} onClick={() => searchBtnCall()}>
                                {t('common.search')}
                            </Button>
                            <Button variant="contained" sx={{ alignSelf: "center" }} onClick={() => resetSearch()}>
                                {t('common.reset')}
                            </Button>
                        </Box>

                        <TableContainer component={Paper} className="margin-top-base list-height margin-bottom-xl list-height list-height padding-left-base padding-right-base padding-x-base padding-bottom-base padding-top-none shadow-0 border-light border-radius">
                            <Table>
                                <TableHead>
                                    <TableRow sx={{ borderBottom: "2px solid", borderColor: "primary.main" }}>
                                        {/*<TableCell>{t('dashboardGroup.countryName')}</TableCell>*/}
                                        <TableCell>{t('dashboardGroup.country')}</TableCell>
                                        <TableCell>{t('dashboardGroup.status')}</TableCell>
                                        <TableCell>{t('common.createdBy')}</TableCell>
                                        <TableCell>{t('common.createdDate')}</TableCell>
                                        <TableCell align="center">{t('common.Action')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedCountryList?.length > 0 ? (
                                        paginatedCountryList?.map((country, index) => (
                                            <TableRow key={index}>
                                                {/*<TableCell sx={{ width: '20rem', wordWrap: "break-word", whiteSpace: "normal", wordBreak: "break-word" }}>{dashboardGroup.dashboardGroup}</TableCell>*/}
                                                <TableCell>{country.countryName}</TableCell>
                                                <TableCell>{country.status}</TableCell>
                                                <TableCell>{country.createdUser}</TableCell>
                                                <TableCell>{country.createdDate}</TableCell>
                                                <TableCell align="center">
                                                    <Box display="flex" justifyContent="center">
                                                        {country.status == 'Active' ? <>
                                                            <Button className="padding-right-none">
                                                                <Tooltip title="Remove">
                                                                    <Icon className='fa-light fa-trash-can font-size-base text-primary' onClick={() => toggleDeleteModal(country.countryID, country.countryName)} />
                                                                </Tooltip>
                                                            </Button>
                                                        </> : <></>}
                                                        <Button className="padding-right-none">
                                                            <Tooltip title="Edit">
                                                                <Icon className='fa-light fa-pen-to-square font-size-base text-primary' onClick={() => editGroup(country.countryID)} />
                                                            </Tooltip>
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))) : (
                                        <TableCell colSpan={4}>{t('common.noRecordsFound')}</TableCell>
                                    )}
                                </TableBody>
                            </Table>
                            <CommonPagination totalItems={totalItems} currentPage={currentPage} onPageChange={setCurrentPage} />
                        </TableContainer>
                        <Dialog className="border-radius-soft padding-y-base padding-x-base text-align-center countryListDialog"
                            open={isDeleteModal}>
                            <DialogTitle>
                                <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left "
                                    variant="h6">{t('dashboardGroup.deleteDashboardGroup')}
                                </Typography>
                            </DialogTitle>

                            <DialogContent>
                                <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                    {t('common.deleteMessage')}
                                </Typography>
                            </DialogContent>

                            <DialogActions className="dialogAction">
                                <Button variant="outlined" startIcon={<Cancel />}
                                    onClick={() => toggleDeleteModal('', '')}
                                    className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                >{t('common.Cancel')}
                                </Button>
                                <Button variant="contained" onClick={() => handleDelete(editCountryID)}
                                    startIcon={<Delete />} className=" border-size-s border-radius-soft del-pop-btn add-dashbaord-btn"
                                >{t('common.Delete')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </section>
                </Box>
            </main>
            {ToastComponent}
        </>
    );
}

export default withTranslation()(CountryList);
